import type { AiTask } from 'types/AiTask';
import type { AlignmentSuggestionsResponse } from 'types/AlignmentSuggestions';
import type { GoalSuggestion } from 'types/GoalSuggestions';
import type { NudgePreview } from 'types/Nudge';

import { getRequest, postRequest } from '../../methods';

const getAiTask = <TOutput>(id: number): Promise<AiTask<TOutput>> =>
  getRequest(`ai_tasks/${id}`);

const createGoalAlignmentSuggestionTask = (
  goalId: number
): Promise<AiTask<AlignmentSuggestionsResponse>> =>
  postRequest(`ai_tasks/goal_alignment_suggestion`, { goal_id: goalId });

const createNudgePreviewTask = ({
  nudgeSettingId,
  teamId,
  cycleId,
}: {
  nudgeSettingId: number;
  teamId: number;
  cycleId: number;
}): Promise<AiTask<NudgePreview[]>> =>
  postRequest('ai_tasks/nudge_preview', {
    nudgeSettingId,
    args: { teamId, cycleId },
  });

const createGoalSuggestionTask = (payload: {
  draftingInput: string;
  kind: 'team' | 'business_unit' | 'organization';
  selectedCycleId: number;
  teamId?: number;
  businessUnitId?: number;
}): Promise<AiTask<GoalSuggestion>> =>
  postRequest(`ai_tasks/goal_suggestion`, payload);

const aiTasks = {
  getAiTask,
  createGoalAlignmentSuggestionTask,
  createNudgePreviewTask,
  createGoalSuggestionTask,
};

export default aiTasks;
